import styled from 'styled-components'

export const StyledWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: absolute;
  right: 15px;
  top: 25px;
`

export const StyledBalanceLabel = styled.div`
  color: #604dbc;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.2px;
  line-height: 16px;
`

export const StyledMaxButton = styled.button`
  background: #d8d1fa;
  border: none;
  border-radius: 20px;
  color: #5f4dbc;
  cursor: pointer;
  font-weight: 500;
  font-size: 10px;
  letter-spacing: 0.2px;
  line-height: 16px;
  margin-left: 10px;
  outline: none;
  padding: 1px 4px;
`
